export default "__VITE_ASSET__7c924299__"